import { motion } from "framer-motion";

export function ListIcon() {
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="30"
      viewBox="0 0 56 30"
      fill="none"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <rect
        x="0.5"
        y="0.5"
        width="54.9988"
        height="28.3594"
        rx="8.5"
        stroke="#5B4E3C"
      />
      <rect
        x="2.66016"
        y="2.66016"
        width="24.04"
        height="24.04"
        rx="6.5"
        fill="#5B4E3C"
        stroke="#5B4E3C"
      />
      <rect
        x="7.47949"
        y="8.20117"
        width="2.88"
        height="2.88"
        rx="1"
        fill="#E7D4B9"
      />
      <rect
        x="11.7993"
        y="8.20117"
        width="10.08"
        height="2.88"
        rx="1"
        fill="#E7D4B9"
      />
      <rect
        x="7.47949"
        y="13.2402"
        width="2.88"
        height="2.88"
        rx="1"
        fill="#E7D4B9"
      />
      <rect
        x="11.7993"
        y="13.2402"
        width="10.08"
        height="2.88"
        rx="1"
        fill="#E7D4B9"
      />
      <rect
        x="7.47949"
        y="18.2812"
        width="2.88"
        height="2.88"
        rx="1"
        fill="#E7D4B9"
      />
      <rect
        x="11.7993"
        y="18.2812"
        width="10.08"
        height="2.88"
        rx="1"
        fill="#E7D4B9"
      />
      <path
        d="M41.5994 8.47852C41.5994 7.92623 42.0492 7.47139 42.5962 7.54785C43.199 7.63211 43.79 7.79265 44.3547 8.02658C45.2283 8.38842 46.022 8.91877 46.6906 9.58735C47.3592 10.2559 47.8895 11.0497 48.2513 11.9232C48.6132 12.7967 48.7994 13.733 48.7994 14.6785C48.7994 15.624 48.6132 16.5603 48.2513 17.4338C47.8895 18.3074 47.3592 19.1011 46.6906 19.7697C46.022 20.4383 45.2283 20.9686 44.3547 21.3304C43.79 21.5644 43.199 21.7249 42.5962 21.8092C42.0492 21.8856 41.5994 21.4308 41.5994 20.8785V19.9985C41.5994 19.4462 42.053 19.01 42.5905 18.8833C42.8161 18.8301 43.0375 18.7588 43.2526 18.6697C43.7767 18.4526 44.253 18.1344 44.6541 17.7332C45.0553 17.3321 45.3735 16.8558 45.5906 16.3317C45.8077 15.8076 45.9194 15.2458 45.9194 14.6785C45.9194 14.1112 45.8077 13.5494 45.5906 13.0253C45.3735 12.5012 45.0553 12.025 44.6541 11.6238C44.253 11.2227 43.7767 10.9045 43.2526 10.6874C43.0375 10.5983 42.8161 10.5269 42.5905 10.4737C42.053 10.347 41.5994 9.9108 41.5994 9.35852V8.47852Z"
        fill="#5B4E3C"
      />
      <path
        d="M35.9441 12.1375C35.4403 11.9111 35.2098 11.3144 35.5037 10.8468C36.0113 10.0392 36.6762 9.33766 37.4623 8.78576C38.2484 8.23387 39.1341 7.8468 40.0661 7.64367C40.6057 7.52606 41.0887 7.94557 41.1305 8.49628L41.197 9.37375C41.2388 9.92446 40.8195 10.3937 40.2931 10.5608C39.8756 10.6932 39.4788 10.889 39.1172 11.1429C38.7555 11.3968 38.4366 11.7035 38.1702 12.0512C37.8343 12.4896 37.2505 12.7245 36.7468 12.4981L35.9441 12.1375Z"
        fill="#5B4E3C"
      />
      <path
        d="M41.0803 20.8567C41.034 21.4071 40.5477 21.8227 40.009 21.7007C39.2615 21.5314 38.5437 21.2433 37.8836 20.8456C36.937 20.2752 36.1344 19.4947 35.538 18.5643C34.9416 17.634 34.5673 16.5788 34.4442 15.4806C34.3584 14.7147 34.3963 13.9421 34.5545 13.1922C34.6685 12.6518 35.2492 12.3834 35.7686 12.5711L36.5962 12.8702C37.1156 13.0579 37.3717 13.6328 37.3081 14.1814C37.2706 14.5053 37.2697 14.8335 37.3063 15.1598C37.3802 15.8187 37.6047 16.4518 37.9626 17.01C38.3204 17.5682 38.802 18.0365 39.3699 18.3787C39.6511 18.5482 39.9497 18.6844 40.2597 18.7855C40.7848 18.9568 41.2002 19.4295 41.1539 19.9798L41.0803 20.8567Z"
        fill="#5B4E3C"
      />
    </motion.svg>
  );
}

export function ChartIcon() {
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="30"
      viewBox="0 0 56 30"
      fill="none"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <rect
        x="0.5"
        y="0.5"
        width="54.9988"
        height="28.3594"
        rx="8.5"
        stroke="#5B4E3C"
      />
      <rect
        x="29.5"
        y="2.5"
        width="24.04"
        height="24.04"
        rx="6.5"
        fill="#5B4E3C"
        stroke="#5B4E3C"
      />
      <rect
        x="7.47949"
        y="8.20117"
        width="2.88"
        height="2.88"
        rx="1"
        fill="#5B4E3C"
      />
      <rect
        x="11.7993"
        y="8.20117"
        width="10.08"
        height="2.88"
        rx="1"
        fill="#5B4E3C"
      />
      <rect
        x="7.47949"
        y="13.2402"
        width="2.88"
        height="2.88"
        rx="1"
        fill="#5B4E3C"
      />
      <rect
        x="11.7993"
        y="13.2402"
        width="10.08"
        height="2.88"
        rx="1"
        fill="#5B4E3C"
      />
      <rect
        x="7.47949"
        y="18.2812"
        width="2.88"
        height="2.88"
        rx="1"
        fill="#5B4E3C"
      />
      <rect
        x="11.7993"
        y="18.2812"
        width="10.08"
        height="2.88"
        rx="1"
        fill="#5B4E3C"
      />
      <path
        d="M41.201 8C41.201 7.44772 41.6508 6.99287 42.1978 7.06933C42.8005 7.15359 43.3915 7.31413 43.9563 7.54807C44.8298 7.9099 45.6236 8.44025 46.2921 9.10883C46.9607 9.77741 47.4911 10.5711 47.8529 11.4447C48.2147 12.3182 48.401 13.2545 48.401 14.2C48.401 15.1455 48.2147 16.0818 47.8529 16.9553C47.4911 17.8289 46.9607 18.6226 46.2921 19.2912C45.6236 19.9598 44.8298 20.4901 43.9563 20.8519C43.3915 21.0859 42.8005 21.2464 42.1978 21.3307C41.6508 21.4071 41.201 20.9523 41.201 20.4V19.52C41.201 18.9677 41.6545 18.5315 42.1921 18.4048C42.4176 18.3516 42.6391 18.2803 42.8542 18.1912C43.3783 17.9741 43.8545 17.6559 44.2557 17.2547C44.6568 16.8536 44.975 16.3773 45.1921 15.8532C45.4092 15.3291 45.521 14.7673 45.521 14.2C45.521 13.6327 45.4092 13.0709 45.1921 12.5468C44.975 12.0227 44.6568 11.5464 44.2557 11.1453C43.8545 10.7441 43.3783 10.4259 42.8542 10.2088C42.6391 10.1197 42.4176 10.0484 42.1921 9.99523C41.6545 9.86852 41.201 9.43228 41.201 8.88V8Z"
        fill="#E4D1B6"
      />
      <path
        d="M35.5456 11.6589C35.0419 11.4326 34.8113 10.8359 35.1052 10.3683C35.6129 9.56071 36.2778 8.85914 37.0639 8.30725C37.85 7.75535 38.7357 7.36829 39.6677 7.16516C40.2073 7.04754 40.6903 7.46706 40.732 8.01776L40.7986 8.89524C40.8404 9.44594 40.4211 9.91523 39.8947 10.0822C39.4772 10.2147 39.0804 10.4104 38.7187 10.6643C38.3571 10.9183 38.0382 11.225 37.7718 11.5726C37.4359 12.011 36.8521 12.246 36.3483 12.0196L35.5456 11.6589Z"
        fill="#E4D1B6"
      />
      <path
        d="M40.6818 20.3782C40.6356 20.9286 40.1492 21.3441 39.6106 21.2222C38.8631 21.0529 38.1453 20.7648 37.4851 20.3671C36.5386 19.7967 35.736 19.0161 35.1396 18.0858C34.5432 17.1554 34.1689 16.1003 34.0458 15.0021C33.9599 14.2362 33.9978 13.4636 34.1561 12.7137C34.2701 12.1733 34.8507 11.9049 35.3701 12.0926L36.1977 12.3917C36.7171 12.5794 36.9732 13.1543 36.9097 13.7029C36.8721 14.0268 36.8713 14.355 36.9079 14.6812C36.9817 15.3402 37.2063 15.9733 37.5641 16.5315C37.922 17.0897 38.4035 17.558 38.9715 17.9002C39.2526 18.0696 39.5512 18.2059 39.8613 18.307C40.3863 18.4783 40.8017 18.951 40.7555 19.5013L40.6818 20.3782Z"
        fill="#E4D1B6"
      />
    </motion.svg>
  );
}
